import React, { useEffect, useRef, useState } from 'react';

import './Benefits.scss';

const stats = [
  { value: '86%', label: 'less junk mail in 4 weeks' },
  { value: '1 hr', label: 'saved every week' },
  { value: (1058).toLocaleString() + ' oz', label: 'CO\u2082 reduced per year' },
];

const Benefits = () => {
  const gridRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = gridRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="benefits" className="BenefitsBand">
      <div className="BenefitsBand__inner">
        <h2>The results, measured.</h2>
        <div
          ref={gridRef}
          className={`BenefitsBand__grid${visible ? ' is-visible' : ''}`}
        >
          {stats.map((s) => (
            <div key={s.label} className="BenefitsBand__stat">
              <div className="BenefitsBand__number">{s.value}</div>
              <div className="BenefitsBand__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
